import styled from "styled-components";

export const HeaderContent = styled.div`
  position: absolute;
  top: 28%;
  left: 0;
  right: 0;
  color: #fff;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding: 0px 20px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 1);
  @media (max-width: 321px) {
    top: 30px;
  }
`;
